
import React, { useState, ReactNode } from "react";
import { AppContext } from "@/hooks/use-app-context";

export type Message = {
  id: string;
  text: string;
  sender: "user" | "bot";
  timestamp: Date;
};

export const AppProvider = ({ children }: { children: ReactNode }) => {
  // Widget state
  const [widgetOpen, setWidgetOpen] = useState(false);
  
  
  // Message state
  const [messages, setMessages] = useState<Message[]>([
    {
      id: "welcome",
      text: "Hello! How can I help you today?",
      sender: "bot",
      timestamp: new Date(),
    },
  ]);
  const [isTyping, setIsTyping] = useState(false);

  // Widget functions
  const toggleWidget = () => {
    setWidgetOpen(prev => !prev);
  };
  
  
  // Message functions
  const addMessage = (message: Omit<Message, "id">) => {
    const newMessage: Message = {
      ...message,
      id: Math.random().toString(36).substr(2, 9),
    };
    
    setMessages(prev => [...prev, newMessage]);
  };

  const value = {
    widgetOpen,
    toggleWidget,
    messages,
    addMessage,
    isTyping,
    setIsTyping,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
